import { render, staticRenderFns } from "./CohortsListFilters.vue?vue&type=template&id=5a279d18&"
import script from "./CohortsListFilters.vue?vue&type=script&lang=js&"
export * from "./CohortsListFilters.vue?vue&type=script&lang=js&"
import style0 from "./CohortsListFilters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports